module.exports = __webpack_public_path__ + "static/media/ic-cross-audit.1629d9ef.svg";